module.exports = __webpack_public_path__ + "img/badge_nft_supported.da12bd0.svg";